export default "__VITE_ASSET__nZTFF84V__"